<template>
  <div class="dashboard-wrapper">
    <div class="card-wrapper card-wrap">
      <div class="card card-dashboard border-0 shadow card-size-big">
        <div class="card-body" v-if="data.count">
          <h6 class="card-subtitle mb-2 text-muted">ACCOUNTS</h6>
          <h3 class="card-title">{{ data.count }}</h3>
        </div>
      </div>
    </div>
    <div class="hours-wrapper">
      <div class="card-wrapper">
        <div class="card border-0 shadow">
          <div
            class="card-body card-dashboard hours-card"
            @click="switchMode()"
          >
            <h6 class="card-subtitle mb-2 text-muted">HOURS <br />(DAY)</h6>
            <div v-if="!isNaN(data.sumDay)" class="hours-card-body-size">
              <h4 class="card-title" v-if="periodTotal">
                <span class="title-card-size-hours">{{
                  decimalToHoursAndMinutes(data.sumDay)
                }}</span>
              </h4>
              <ul class="period-detail-list" v-else>
                <li>
                  <font-awesome-icon icon="dollar-sign" color="green" />
                  <span class="bold">{{
                    decimalToHoursAndMinutes(data.dayDetail.clientBillable)
                  }}</span>
                </li>
                <li>
                  <font-awesome-icon icon="dollar-sign" color="red" />
                  <span class="bold">{{
                    decimalToHoursAndMinutes(data.dayDetail.clientNonBillable)
                  }}</span>
                </li>
                <li>
                  <font-awesome-icon
                    icon="user"
                    color="#6C757D"
                    class="user-icon"
                  />
                  <span class="bold">{{
                    decimalToHoursAndMinutes(data.dayDetail.internal)
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="card-wrapper">
        <div class="card border-0 shadow">
          <div
            class="card-body card-dashboard hours-card-mid"
            @click="switchMode()"
          >
            <h6 class="card-subtitle mb-2 text-muted">HOURS <br />(WEEK)</h6>
            <div v-if="!isNaN(data.sumWeek)">
              <h4 class="card-title" v-if="periodTotal">
                <span class="title-card-size-hours">{{
                  decimalToHoursAndMinutes(data.sumWeek)
                }}</span>
              </h4>
              <ul class="period-detail-list" v-else>
                <li>
                  <font-awesome-icon icon="dollar-sign" color="green" />
                  <span class="bold">{{
                    decimalToHoursAndMinutes(data.weekDetail.clientBillable)
                  }}</span>
                </li>
                <li>
                  <font-awesome-icon icon="dollar-sign" color="red" />
                  <span class="bold">{{
                    decimalToHoursAndMinutes(data.weekDetail.clientNonBillable)
                  }}</span>
                </li>
                <li>
                  <font-awesome-icon
                    icon="user"
                    color="#6C757D"
                    class="user-icon"
                  />
                  <span class="bold">{{
                    decimalToHoursAndMinutes(data.weekDetail.internal)
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="card-wrapper">
        <div class="card border-0 shadow">
          <div
            class="card-body card-dashboard hours-card"
            @click="switchMode()"
          >
            <h6 class="card-subtitle mb-2 text-muted">HOURS <br />(MONTH)</h6>
            <div v-if="!isNaN(data.sumMonth)">
              <h4 class="card-title" v-if="periodTotal">
                <span class="title-card-size-hours">{{
                  decimalToHoursAndMinutes(data.sumMonth)
                }}</span>
              </h4>
              <ul class="period-detail-list" v-else>
                <li>
                  <font-awesome-icon icon="dollar-sign" color="green" />
                  <span class="bold">{{
                    decimalToHoursAndMinutes(data.monthDetail.clientBillable)
                  }}</span>
                </li>
                <li>
                  <font-awesome-icon icon="dollar-sign" color="red" />
                  <span class="bold">{{
                    decimalToHoursAndMinutes(data.monthDetail.clientNonBillable)
                  }}</span>
                </li>
                <li>
                  <font-awesome-icon
                    icon="user"
                    color="#6C757D"
                    class="user-icon"
                  />
                  <span class="bold">{{
                    decimalToHoursAndMinutes(data.monthDetail.internal)
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-wrapper">
      <div class="card border-0 shadow shadow card-size-big">
        <div class="card-body card-dashboard">
          <h6 class="card-subtitle mb-2 text-muted">ARR</h6>
          <h5 class="card-title" v-if="arr">{{ arr.toLocaleString() }}</h5>
          <p class="card-text">(USD)</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  props: ["data", "arr"],
  data() {
    return {
      periodTotal: true,
      weekTotal: true,
      monthTotal: true,
    };
  },
  methods: {
    decimalToHoursAndMinutes: function (decimalTime) {
      if (decimalTime === 0) {
        return "00 : 00";
      } else {
        var hour = Math.floor(decimalTime);
        var minute = (decimalTime - hour) * 60;
        if (hour < 10) {
          hour = "0" + hour;
        }
        if (minute < 10) {
          minute = "0" + minute;
        }
        return hour + " : " + minute;
      }
    },
    switchMode: function () {
      this.periodTotal = !this.periodTotal;
    },
  },
});
</script>

<style lang="scss">
.dashboard-wrapper {
  @media (min-width: 50px) {
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 100%;
  }
  @media (min-width: 768px) {
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding: 0 !important;
    width: 100%;
    display: flex;
    flex-direction: row;
  }
  @media (min-width: 1024px) {
    width: 95%;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
  }
}

.card-wrapper {
  @media (min-width: 50px) {
    width: 99%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  @media (min-width: 768px) {
    width: 99%;
    display: flex;
    flex-direction: row;
    margin: 0 !important;
    padding: 0 !important;
  }
  @media (min-width: 1024px) {
    width: 99%;
    display: flex;
    flex-direction: row;
    margin: 0 !important;
    padding: 0 !important;
    gap: 0 !important;
  }
}

.card-size-big {
  @media (min-width: 50px) {
    width: 100%;
  }
  @media (min-width: 768px) {
    width: max-content !important;
  }
  @media (min-width: 1024px) {
    width: 80% !important;
    height: max-content !important;
  }
}

.hours-wrapper {
  @media (min-width: 50px) {
    width: 100vw;
    margin: 0 !important;
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  @media (min-width: 375px) {
    width: 100%;
    margin: 0 !important;
    padding: 0 !important;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  @media (min-width: 768px) {
    width: 100%;
    height: max-content;
    margin: 0 !important;
    padding: 0 !important;
    display: flex;
    flex-direction: row;
  }
  @media (min-width: 1024px) {
    width: 100%;
    height: max-content;
    margin: 0 !important;
    padding: 0 !important;
    display: flex;
    flex-direction: row;
    gap: 0 !important;
  }
}

.hours-card {
  @media (min-width: 50px) {
    width: 92.75vw !important;
    height: max-content !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  @media (min-width: 375px) {
    width: max-content !important;
    height: max-content !important;
  }
  @media (min-width: 768px) {
    width: 15vw !important;
    height: max-content !important;
  }
  @media (min-width: 1024px) {
    width: 14vw !important;
    height: 100% !important;
  }
}

.hours-card-mid {
  @media (min-width: 50px) {
    width: 92.75vw !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  @media (min-width: 375px) {
    width: max-content !important;
    height: max-content !important;
    margin-left: 1vw;
    margin-right: 1vw;
  }
  @media (min-width: 768px) {
    width: 15vw !important;
    height: max-content !important;
  }
  @media (min-width: 1024px) {
    width: 14vw !important;
    height: max-content !important;
    margin: 0 !important;
  }
}

.title-card-size-hours {
  @media (min-width: 50px) {
    // make the title fit in the card
    font-size: 1.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.hours-card-body-size {
  @media (min-width: 1024px) {
    width: 100% !important;
    height: 100% !important;
  }
}

.card-dashboard {
  cursor: pointer;
}
.bold {
  font-weight: bold;
}
.period-detail-list {
  margin-top: 12px;
  list-style-type: none;
  font-size: 14px;
  padding-left: 0px;
}

.user-icon {
  font-size: 12px;
}
</style>
